import { useEffect, useRef } from "react";
import ReactDOMServer from "react-dom/server";
import { makeIntComma } from "hooks/utils/util";
import { DeliveryData } from "./SearchSidebar";
import { useMapStore } from "store/useMapStore";
import pin from "assets/morning/map/pin.png";
import pin_p_on from "assets/morning/map/pin_p_on.png";
import pin_d_on from "assets/morning/map/pin_d_on.png";
import pin_loca from "assets/morning/map/pin_loca.png";
import pin_loca_on from "assets/morning/map/pin_loca_on.png";

export interface MarkerData {
    lat: number;
    lng: number;
    isOpen: boolean;
    isDelivery: boolean; // 운송장인지 체크값
    isOrigin?: boolean; // 운송장일때 배송 출발지,도착지인지 체크값
    isCourierAssigned?: boolean; // 운송장일때 담당기사인지 체크값
    isPickup: boolean; // 담당기사일때 픽업,배달인지 체크값
    markerData: DeliveryData;
    _marker?: naver.maps.Marker; // 마커 객체를 저장하기 위한 선택 속성
    index?: string | number;
}

export interface MapCenterData {
    lat: number;
    lng: number;
}

export interface MarkerData {
    lat: number;
    lng: number;
    isOpen: boolean;
    isDelivery: boolean; // 운송장인지 체크값
    isOrigin?: boolean; // 운송장일때 배송 출발지,도착지인지 체크값
    isCourierAssigned?: boolean; // 운송장일때 담당기사인지 체크값
    isPickup: boolean; // 담당기사일때 픽업,배달인지 체크값
    markerData: DeliveryData;
    _marker?: naver.maps.Marker; // 마커 객체를 저장하기 위한 선택 속성
    index?: string | number;
}

export interface MapCenterData {
    lat: number;
    lng: number;
}

interface InfoWindowContentProps {
    isDelivery: boolean;
    isOrigin: boolean;
    isCourierAssigned: boolean;
    isPickup: boolean;
    data: DeliveryData;
}

const InfoWindowContent = ({ isDelivery, isOrigin, isCourierAssigned, isPickup, data }: InfoWindowContentProps) => {
    const contact = isOrigin ? data.S_C_Contact : data.S_B_Contact;
    const kind = isOrigin ? data.cKind : data.bKind;
    const tel = isOrigin ? data.S_C_tel : data.S_B_tel;
    const addr = isOrigin ? data.S_C_Addr1 : data.S_B_Addr1;
    const count1 = isOrigin ? data.S_C_cnt1 : data.S_B_cnt1;
    const count2 = isOrigin ? data.S_C_cnt2 : data.S_B_cnt2;
    const count3 = isOrigin ? data.S_C_cnt3 : data.S_B_cnt3;
    const courierType = isCourierAssigned ? (isPickup ? "픽업담당" : "배송담당") : data.d_kind_name;
    const courierDate = isCourierAssigned ? (isPickup ? data.pickup_reg_date : data.bpickup_reg_date) : data.reg_date;
    const courierName = isCourierAssigned ? (isPickup ? data.pickupName : data.bpickupName) : data.d_name;
    const courierTel = isCourierAssigned ? (isPickup ? data.pickup_tel : data.bpickup_tel) : data.d_e_tel;

    return (
        <>
            {isDelivery ? ( //운송장일때
                <div className="w-[360px] bg-white shadow-[4px_4px_8px_0px_rgba(202,214,222,0.60)] flex flex-col gap-[8px] p-[12px_16px]">
                    <div className="flex items-center justify-between">
                        <p className="flex items-center gap-[8px]">
                            <strong className="text-[20px] font-[500]">{contact}</strong>
                            <span className="text-[14px] text-[#878A93]">실주소지</span>
                        </p>
                        <div className="p-[6px_12px] bg-[#FEEEE5] text-[14px] text-[#FF7B2E] font-[500] rounded-[4px]">{kind}</div>
                    </div>
                    <ul className="flex flex-col gap-[4px] text-[14px] text-[#5A5C63]">
                        <li>{tel}</li>
                        <li>{addr}</li>
                    </ul>
                    <ul className="flex items-center justify-center gap-[17px] p-[16px_8px] bg-[#F3F5F8] rounded-[8px]">
                        <li className="min-w-[93px] flex items-center justify-center gap-[4px] font-[500] relative after:absolute after:content-[''] after:w-[1px] after:h-[20px] after:bg-[#E1E2E4] after:top-1/2 after:-right-[9px] after:-translate-y-1/2">
                            <p className="text-[14px] opacity-[0.5]">접수</p>
                            <p className="text-[#132E47]">{makeIntComma(count1 || 0)} 건</p>
                        </li>
                        <li className="min-w-[93px] flex items-center justify-center gap-[4px] font-[500] relative after:absolute after:content-[''] after:w-[1px] after:h-[20px] after:bg-[#E1E2E4] after:top-1/2 after:-right-[9px] after:-translate-y-1/2">
                            <p className="text-[14px] opacity-[0.5]">배정</p>
                            <p className="text-[#132E47]">{makeIntComma(count2 || 0)} 건</p>
                        </li>
                        <li className="min-w-[93px] flex items-center justify-center gap-[4px] font-[500]">
                            <p className="text-[14px] opacity-[0.5]">완료</p>
                            <p className="text-[#132E47]">{makeIntComma(count3 || 0)} 건</p>
                        </li>
                    </ul>
                </div>
            ) : (
                //담당기사일때
                <div className="w-[280px] bg-white shadow-[4px_4px_8px_0px_rgba(202,214,222,0.60)] flex flex-col gap-[4px] p-[12px_18px] rounded-[8px]">
                    <div className="flex items-center gap-[8px] text-[12px]">
                        <p className={`text-white font-[700] p-[4px_8px] rounded-[8px] ${isPickup ? "bg-[#6541F2]" : "bg-[#F553DA]"}`}>
                            {courierType}
                        </p>
                        <p className="text-[#878A93]">{courierDate}</p>
                    </div>
                    <div className="flex items-center gap-[4px]">
                        <p className="text-[18px] text-[#1B1C1E] font-[700]">{courierName}</p>
                        <p className="text-[15px] text-[#5A5C63] font-[500]">{courierTel}</p>
                    </div>
                </div>
            )}
        </>
    );
};

export default function Map() {
    const { markersData, mapCenter, mapZoom, setMapZoom } = useMapStore();
    const mapRef = useRef<naver.maps.Map>();
    const markersRef = useRef<naver.maps.Marker[]>([]);
    const infoWindowsRef = useRef<naver.maps.InfoWindow[]>([]);

    // 지도 생성
    useEffect(() => {
        if (!window.naver) return;

        const map = new window.naver.maps.Map("map", {
            center: new window.naver.maps.LatLng(mapCenter.lat, mapCenter.lng),
            zoom: mapZoom,
            zoomControl: true,
            zoomControlOptions: {
                position: naver.maps.Position.RIGHT_BOTTOM,
                style: naver.maps.ZoomControlStyle.SMALL,
            },
        });

        mapRef.current = map; // 생성된 지도를 Ref에 저장
    }, []);

    const showMarker = (map: naver.maps.Map, marker: naver.maps.Marker) => {
        if (!marker.getMap()) marker.setMap(map);
    };

    const hideMarker = (marker: naver.maps.Marker) => {
        if (marker.getMap()) marker.setMap(null);
    };

    // 마커 갱신 및 MarkerClustering 적용
    useEffect(() => {
        if (!mapRef.current) return;

        const map = mapRef.current;

        // 기존 마커와 정보창 제거
        markersRef.current.forEach(marker => marker.setMap(null));
        infoWindowsRef.current.forEach(infoWindow => infoWindow.close());

        // 마커 및 정보창 배열 초기화
        markersRef.current = [];
        infoWindowsRef.current = [];

        // 기존 MarkerClustering 해제
        let markerClustering: any = null;

        // 기존 마커와 정보창을 업데이트
        markersData.forEach((markerData, index) => {
            // 마커 생성
            const marker = new window.naver.maps.Marker({
                position: new window.naver.maps.LatLng(markerData.lat, markerData.lng),
                map: map,
                icon: {
                    url: markerData.isDelivery ? pin_loca : pin,
                    size: new window.naver.maps.Size(42, 42),
                },
            });

            // 정보창 생성
            const contentHtml = ReactDOMServer.renderToString(
                <InfoWindowContent
                    isDelivery={markerData.isDelivery}
                    isOrigin={markerData.isOrigin || false}
                    isCourierAssigned={markerData.isCourierAssigned || false}
                    isPickup={markerData.isPickup}
                    data={markerData.markerData}
                />,
            );

            const infoWindow = new window.naver.maps.InfoWindow({
                content: contentHtml,
                borderWidth: 0,
                backgroundColor: "transparent",
                anchorSize: new naver.maps.Size(18, 15),
            });

            // 마커 클릭 이벤트 등록
            window.naver.maps.Event.addListener(marker, "click", () => {
                if (markerData.isOpen) {
                    infoWindow.close();
                    marker.setIcon({
                        url: markerData.isDelivery ? pin_loca : pin,
                    });
                    markerData.isOpen = false;
                } else {
                    // 모든 다른 마커와 정보창 초기화
                    markersData.forEach((otherMarkerData, otherIndex) => {
                        if (otherIndex !== index) {
                            otherMarkerData.isOpen = false;
                            infoWindowsRef.current[otherIndex].close();
                            markersRef.current[otherIndex].setIcon({
                                url: otherMarkerData.isDelivery ? pin_loca : pin,
                            });
                        }
                    });

                    // 현재 클릭된 마커의 정보창 열기
                    infoWindow.open(map, marker);
                    marker.setIcon({
                        url: markerData.isDelivery ? pin_loca_on : markerData.isPickup ? pin_p_on : pin_d_on,
                    });
                    markerData.isOpen = true;
                }
            });

            // `isOpen` 상태에 따라 정보창 초기 상태 설정
            if (markerData.isOpen) {
                infoWindow.open(map, marker);
                marker.setIcon({
                    url: markerData.isDelivery ? pin_loca_on : markerData.isPickup ? pin_p_on : pin_d_on,
                });
            }

            // 배열에 마커와 정보창 저장
            markersRef.current.push(marker);
            infoWindowsRef.current.push(infoWindow);
        });

        // 현재 지도 영역 내 마커 업데이트 및 클러스터링
        const updateVisibleMarkersAndCluster = () => {
            if (!map) return;

            const mapBounds = map.getBounds();
            const visibleMarkers: naver.maps.Marker[] = [];

            markersRef.current.forEach(marker => {
                const position = marker.getPosition();
                if (mapBounds.hasPoint(position)) {
                    showMarker(map, marker); // 지도에 표시
                    visibleMarkers.push(marker); // 클러스터링에 포함
                } else {
                    hideMarker(marker); // 지도에서 숨김
                }
            });

            // 클러스터링 갱신
            if (markerClustering) {
                markerClustering.setMap(null); // 기존 클러스터링 해제
            }

            markerClustering = new window.MarkerClustering({
                map: map,
                markers: visibleMarkers, // 현재 지도 영역 내 마커만 클러스터링
                gridSize: 80, // 클러스터를 형성할 그리드 크기 (픽셀 단위)
                minClusterSize: 2, // 클러스터가 형성되기 위한 최소 마커 수
                maxZoom: 16, // 해당 줌 레벨 이상에서는 클러스터가 해제됨
                disableClickZoom: false,
                icons: [
                    {
                        content: `
                            <div class="w-[40px] h-[40px] rounded-full relative after:absolute after:content-[''] after:w-full after:h-full after:border-2 after:border-[#70b52b] after:rounded-full before:absolute before:content-[''] before:w-[32px] before:h-[32px] before:bg-[#70b52b] before:rounded-full before:top-[4px] before:left-[4px] -z-[1]"></div>
                        `,
                        size: new window.naver.maps.Size(40, 40),
                        anchor: new naver.maps.Point(20, 20),
                    },
                ],
                stylingFunction: (clusterMarker, count) => {
                    const element = clusterMarker.getElement();
                    element.innerHTML = `<p class="absolute w-full text-center leading-[38px] text-[13px] text-white pointer-events-none">${count}</p>`;
                },
            });
        };

        // 초기 업데이트
        updateVisibleMarkersAndCluster();

        // 지도 이동/줌 이벤트로 마커 및 클러스터링 업데이트
        const idleListener = naver.maps.Event.addListener(map, "idle", () => {
            updateVisibleMarkersAndCluster();

            //변경된 zoom 저장
            const updatedMapZoom = map.getZoom();
            setMapZoom(updatedMapZoom);
        });

        return () => {
            if (markerClustering) markerClustering.setMap(null); // 클러스터링 해제
            markersRef.current.forEach(marker => marker.setMap(null)); // 마커 제거
            naver.maps.Event.removeListener(idleListener);
        };
    }, [markersData]);

    // 지도 확대값 변경시 적용
    useEffect(() => {
        if (mapRef.current) {
            mapRef.current.setZoom(mapZoom);
        }
    }, [mapZoom]);

    // 지도 중심위치값 변경시 적용
    useEffect(() => {
        if (mapRef.current) {
            const updatedCenter = new naver.maps.LatLng(mapCenter.lat, mapCenter.lng);
            mapRef.current.setCenter(updatedCenter);
        }
    }, [mapCenter]);

    return <div className="w-full h-[calc(100vh-124px)] naver-map" id="map" />;
}
